import { render, staticRenderFns } from "./SearchingResultItem.vue?vue&type=template&id=0bd93f88"
import script from "./SearchingResultItem.vue?vue&type=script&lang=js"
export * from "./SearchingResultItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports